export  class BenchModel {
	size: string;
	name: string;
	useCommonStove:boolean;
	fullHeightGlassImage:string;
	halfHeightGlassImage:string;
	public constructor(size: string,name:string,useCommonStove:boolean,fullHeightGlassImage:string,halfHeightGlassImage:string) {
		this.size = size;
		this.name = name;
		this.useCommonStove= useCommonStove;
		this.fullHeightGlassImage= fullHeightGlassImage;
		this.halfHeightGlassImage= halfHeightGlassImage;
	}
}